module.exports = __webpack_public_path__ + "static/media/mazatlan.9330bd58.jpg";